import { Button, FormControl, FormHelperText } from '@mui/material';
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Icon from '@mdi/react';
import { mdiUpload } from '@mdi/js';
import styles from './index.module.scss';
import clsx from 'clsx';

export const FileInput = React.forwardRef(
  (
    {
      name,
      required,
      label,
      buttonText,
      value,
      onChange,
      accept,
      allowEmptyFiles = false,
      ...props
    },
    ref,
  ) => {
    const inputRef = useRef();

    // append file names for multiple files, else show single file name or default label
    const fileLabel = props?.multiple
      ? Array.from(value)
          .map((f) => f.name)
          .join(', ')
      : (value?.name ?? label);
    return (
      <FormControl className={styles.container} ref={ref}>
        <label htmlFor={`file-input-${name}`}>
          <Button
            startIcon={<Icon path={mdiUpload} />}
            className={styles.button}
            variant='outlined'
            color='secondary'
            onClick={() => inputRef.current.click()}
          >
            {buttonText ?? `${value?.length > 0 ? 'Change' : 'Select'} file`}
          </Button>
          <span className={clsx(styles.fileName, value && styles.selected)}>
            {fileLabel}
          </span>
          <input
            {...props}
            ref={inputRef}
            id={`file-input-${name}`}
            className={styles.hiddenInput}
            name={name}
            type='file'
            onChange={onChange}
            required={required}
            accept={accept}
          />
        </label>
        {value?.size === 0 && !allowEmptyFiles && (
          <FormHelperText error>File must not be empty.</FormHelperText>
        )}
      </FormControl>
    );
  },
);

FileInput.defaultProps = {
  onChange: () => null,
  label: 'No file selected',
};

FileInput.displayName = 'FileInput';

FileInput.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      size: PropTypes.number.isRequired,
    }),
    PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        size: PropTypes.number.isRequired,
      }),
    ),
  ]),
  onChange: PropTypes.func,
  required: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool,
  name: PropTypes.string,
  buttonText: PropTypes.string,
  accept: PropTypes.string,
  allowEmptyFiles: PropTypes.bool,
  multiple: PropTypes.bool,
};
